import { BottomSheet, Text, Title, type UseModalState } from "@clipboard-health/ui-components";
import { DialogContent, Stack } from "@mui/material";
import { useCallback } from "react";
import Confetti from "react-confetti";

import { BottomSheetHeader } from "../components/BottomSheetHeader";
import { Button } from "../components/Button";
import { DialogFooter } from "../components/DialogFooter";

interface CbhWrappedBottomSheetProps {
  modalState: UseModalState;
  onClick: () => void;
}

export function CbhWrappedBottomSheet(props: CbhWrappedBottomSheetProps) {
  const { modalState, onClick } = props;

  const handleClose = useCallback(() => {
    modalState.closeModal();
  }, [modalState]);

  return (
    <BottomSheet
      footer={
        <DialogFooter orientation="vertical">
          <Button fullWidth variant="contained" size="large" onClick={onClick}>
            Let&apos;s see!
          </Button>
        </DialogFooter>
      }
      header={<BottomSheetHeader onClose={handleClose} />}
      modalState={modalState}
      paperSx={{
        overflow: "hidden",
      }}
    >
      <DialogContent>
        <Confetti
          width={window.innerWidth}
          height={window.innerHeight}
          numberOfPieces={100}
          gravity={0.2}
        />

        <Stack
          spacing={6}
          sx={{
            height: "100%",
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            textAlign: "center",
            paddingTop: 8,
          }}
        >
          <Title
            semibold
            variant="h3"
            component="h3"
            sx={{ paddingBottom: 6, textWrap: "balance" }}
          >
            Your 2025 Mid-Year Recap is here!
          </Title>

          <Text variant="body1" sx={{ fontSize: "4.75rem" }}>
            🎉
          </Text>

          <Text semibold variant="body1" sx={{ paddingTop: 6 }}>
            You&apos;re one of our top 1,000 performers this year! Tap below to see your highlights
            and celebrate everything you accomplished.
          </Text>

          <Text variant="body1">
            Thanks for being a valued part of the Clipboard Health family!
          </Text>
        </Stack>
      </DialogContent>
    </BottomSheet>
  );
}
